 const StyleSheet = {
  create: (style) => {
    return style;
  }
};
export default StyleSheet;